// import React, { useState } from "react";
// import { BsFillPlusCircleFill } from "react-icons/bs";
// import { TbNumbers } from "react-icons/tb";
// import { boardService } from "../../services/board.service";

// export function DueDate({ customHeight, info, field, onUpdate, userId }) {
//     const [date, setDate] = useState(info.date || '');
//     const [isShowInput, setIsShowInput] = useState(false);
//     const isEditable = [1, 2, 20].includes(userId);

//     console.log("esto trae el campo:, ",info.campo);

//     function handleDateChange({ target }) {
//         setDate(target.value);
//     }

//     function onSave(ev) {
//         console.log('date:', date);
//         const activity = boardService.getEmptyTask();
//         activity.action = 'date';
//         activity.from = info.date || '-';
//         activity.task = { valor2: info.tablaEleccion };

//         if(activity.from === '-' && !date) {
//             setIsShowInput(false);
//             return;
//         } 
//         activity.to = date;
//         onUpdate(ev, field, date);
//     }

//     function onClearDate() {
//         setDate('');
//         const activity = boardService.getEmptyTask();
//         activity.action = 'date';
//         activity.from = info.date || '-';
//         activity.to = '-';
//         activity.task = { valor2: info.tablaEleccion };
//         onUpdate('date', '', activity);
//         console.log('se activa onClearDate' + info.tablaEleccion);
//     }

//     return (
//         <section className="date-picker picker" style={{ textAlign: "center", alignContent: 'center', alignItems: "center", height: customHeight }}>
//             {isEditable ? (
//                 <>
//                     {(!date && !isShowInput) && (
//                         <span onClick={() => setIsShowInput(true)} className="add-date-icons">
//                             <BsFillPlusCircleFill style={{ marginTop: "10px" }} className="plus-icon" />
//                             <TbNumbers />
//                         </span>
//                     )}
//                     {(date || isShowInput) && (
//                         <input
//                             type="date"
//                             name="date"
//                             value={date}
//                             onChange={handleDateChange}
//                             onBlur={(ev) => onSave(ev)}
//                             style={{ fontFamily: "Figtree" }}
//                         />
//                     )}
//                 </>
//             ) : (
//                 <span>{date || 'No date set'}</span>
//             )}
//         </section>
//     );
// }



import React, { useState } from "react";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { TbNumbers } from "react-icons/tb";
import { boardService } from "../../services/board.service";
import{ROLES}from '../../cmps/../services/user.service'

export function DueDate({ customHeight, info, field, onUpdate, userRol }) {
    const [date, setDate] = useState(info.date || '');
    const [isShowInput, setIsShowInput] = useState(false);

    // const isEditable = hasPermission(userRol) || info.campo === "subtask-preview";

    const isEditable = (userRol === ROLES.ADMIN || info.campo === "subtask-preview") && userRol !== ROLES.AUDITOR;

 
    function handleDateChange({ target }) {
        setDate(target.value);
    }

    function onSave(ev) {
        console.log('date:', date);
        const activity = boardService.getEmptyTask();
        activity.action = 'date';
        activity.from = info.date || '-';
        activity.task = { valor2: info.tablaEleccion };

        if(activity.from === '-' && !date) {
            setIsShowInput(false);
            return;
        } 
        activity.to = date;
        onUpdate(ev, field, date);
    }

    function onClearDate() {
        setDate('');
        const activity = boardService.getEmptyTask();
        activity.action = 'date';
        activity.from = info.date || '-';
        activity.to = '-';
        activity.task = { valor2: info.tablaEleccion };
        onUpdate('date', '', activity);
        console.log('se activa onClearDate' + info.tablaEleccion);
    }

    return (
        <section className="date-picker picker" style={{ textAlign: "center", alignContent: 'center', alignItems: "center", height: customHeight, cursor: isEditable ? 'pointer' : 'not-allowed' }}>
            {isEditable ? (
                <>
                    {(!date && !isShowInput) && (
                        <span onClick={() => setIsShowInput(true)} className="add-date-icons">
                            <BsFillPlusCircleFill style={{ marginTop: "10px" }} className="plus-icon" />
                            <TbNumbers />
                        </span>
                    )}
                    {(date || isShowInput) && (
                        <input
                            type="date"
                            name="date"
                            value={date}
                            onChange={handleDateChange}
                            onBlur={(ev) => onSave(ev)}
                            style={{ fontFamily: "Figtree" }}
                        />
                    )}
                </>
            ) : (
                <span>{date || 'No date set'}</span>
            )}
        </section>
    );
}
